export default __webpack_public_path__ + "static/media/Sarabun-ExtraBold.82a84809.ttf";